import {FC, ReactNode, useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import {adminStorage} from '@/utils/services/storage.service';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getErrorMessage} from '@/utils/helpers';
import {Navigate, useMatch} from 'react-router-dom';
import {ROUTER_URL, STORAGE_KEY} from '@/utils/enums';
import {getSuperAdminInfo, getSuperAdminSelector} from '@/store/admin';
import {IAdminInfo} from '@/utils/types/superAdmin.interface';

interface OrganizationPrivateRouteProps {
  children: ReactNode;
}

const AdminPrivateRoute: FC<OrganizationPrivateRouteProps> = ({children}) => {
  const dispatch = useAppDispatch();

  const admin: IAdminInfo | null = useAppSelector(getSuperAdminSelector);
  const isLoginPage = !!useMatch({path: ROUTER_URL.ADMIN, end: true});

  const [isLoading, setIsLoading] = useState(() => !admin && !!adminStorage.get(STORAGE_KEY.SUPER_ADMIN_ID));

  useEffect(() => {
    const adminId = adminStorage.get(STORAGE_KEY.SUPER_ADMIN_ID);

    if (admin || !adminId) return;

    dispatch(getSuperAdminInfo(adminId as number))
      .unwrap()
      .catch((error) => toast.error(getErrorMessage(error)))
      .finally(() => setIsLoading(false));
  }, []);

  if (isLoading) return null;

  if (!admin && !isLoginPage) return <Navigate to={ROUTER_URL.ADMIN} replace />;

  return children;
};

export default AdminPrivateRoute;
